import {isNullOrUndefined} from "../../../services/Validator";

export default function BrevetFiltersSubthemeSelection({ availableSubthemes,
                                                         draftSubthemes,
                                                         handleToggleSubtheme }) {
    // BUILD
    if (isNullOrUndefined(availableSubthemes) || isNullOrUndefined(draftSubthemes))
        return null
    return (
        <div className={"w-full flex flex-col space-y-[8px]"}>
            <span className={"text-white text-[14px] font-bold"}>
                {"Chapitres"}
            </span>
            <div className={"flex flex-col space-y-[8px]"}>
                {availableSubthemes.map((grade, index) => (
                    <div key={index}
                         className={"cursor-pointer flex justify-start items-center space-x-[12px]"}
                         onClick={() => handleToggleSubtheme(grade)}>
                        <div className={`w-[20px] min-w-[20px] h-[20px] min-h-[20px] border-1 ${isItemChecked(grade) ? "border-greenStar bg-greenStar" : "border-greyLight9"} rounded-[2px] flex justify-center items-center`}>
                            {isItemChecked(grade)
                                ? <i className={`material-icons text-[16px] text-primaryDark7`}>
                                    {"check"}
                                </i>
                                : null
                            }
                        </div>
                        <span className={'font-normal text-white text-[14px]'}>
                            {grade}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Check if appliedSubthemes is in a
    function isItemChecked(item) {
        return draftSubthemes.includes(item)
    }
}